// src/services/analyticsService.js
import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "analytics";

export const analyticsService = {
  getDashboardData: async (params = {}) => {
    const { startDate, endDate, shopId, userId, categoryId } = params;
    const queryParams = new URLSearchParams();
    if (startDate) queryParams.append('startDate', startDate);
    if (endDate) queryParams.append('endDate', endDate);
    if (shopId) queryParams.append('shopId', shopId);
    if (userId) queryParams.append('userId', userId);
    if (categoryId) queryParams.append('categoryId', categoryId);

    const response = await axios.get(
      `${apiUrl}/dashboard?${queryParams.toString()}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  getSalesData: async (startDate, endDate) => {
    const response = await axios.get(
      `${apiUrl}/sales?startDate=${startDate}&endDate=${endDate}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  },

  getInventoryData: async () => {
    const response = await axios.get(`${apiUrl}/inventory`, {
      withCredentials: true,
    });
    return response.data;
  },
};
